import { getClassicEnrollmentSection } from 'automation-ui-canvas/containers/settings/v2/SettingsConfigurations';
import SettingsSection from 'automation-ui-canvas/containers/settings/v2/SettingsSection';
import { useQuery } from 'data-fetching-client';
import { useHistory, useLocation } from 'react-router-dom';
import { GET_SFDC_PORTAL_SETTINGS_QUERY } from 'automation-ui-canvas/queries/SalesforceEnabledPortalSettingQuery';
import { Map as ImmutableMap } from 'immutable';
import { useRef } from 'react';
import classicSettingsTranslations from 'i2l?query=sporks!automation-ui-canvas/lang/settings/en.lyaml';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { compose } from 'redux';
import LazyLangLoaderDecorator from 'automation-ui-i18n/LazyLangLoaderDecorator';
import { jsx as _jsx } from "react/jsx-runtime";
const EnrollmentSettingsSection = ({
  flow,
  readOnly,
  classicEnrollmentSettings,
  onChange,
  areLangStringsLoading
}) => {
  const location = useLocation();
  const history = useHistory();
  const refsById = useRef(ImmutableMap());
  const {
    data: salesforcePortalSetting
  } = useQuery(GET_SFDC_PORTAL_SETTINGS_QUERY);
  const {
    modules
  } = getClassicEnrollmentSection();
  if (areLangStringsLoading) {
    return null;
  }
  return /*#__PURE__*/_jsx(SettingsSection, {
    location: location,
    salesforcePortalSetting: salesforcePortalSetting && salesforcePortalSetting.portalSettings,
    history: history,
    flow: flow,
    settings: {
      classicEnrollmentSettings: classicEnrollmentSettings.setting
    },
    onChange: onChange,
    readOnly: readOnly,
    id: "enrollmentSettings",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "settingsV2.enrollmentSettings"
    }),
    modules: modules,
    hasBorder: true,
    use: "accordian",
    scrollTo: () => {},
    refsById: refsById,
    defaultOpen: false
  });
};
export default compose(LazyLangLoaderDecorator([classicSettingsTranslations]))(EnrollmentSettingsSection);